import React from 'react';

const features = [
  {
    id: 1,
    icon: '/home-5/learning/1.svg',
    title: 'Auto-apprentissage guidé',
    description: 'Vidéos, Kits Projets',
    animationDelay: 'delay-100'
  },
  {
    id: 2,
    icon: '/home-5/learning/2.svg',
    title: 'Dojos / Stages en présentiel',
    description: 'Pratique collective',
    animationDelay: 'delay-200'
  },
  {
    id: 3,
    icon: '/home-5/learning/3.svg',
    title: 'Lab / Résidence',
    description: 'Projet intégrateur et certification',
    animationDelay: 'delay-300'
  },
];

const LittleMakerMethodology = () => {
  return (
    <section className="relative py-12 md:py-16 lg:py-24 bg-white dark:bg-dark-2 px-6 md:px-4">
      <div className="absolute inset-0 h-2/3 bg-dark-6"></div>

      <div className="container mx-auto relative z-10">
        {/* Title */}
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 md:mb-4">
            Méthodologie Little Maker
          </h2>
        </div>

        {/* Features - version empilée sur mobile */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-6">
          {features.map((feature) => (
            <div key={feature.id} className="w-full md:w-1/3 transform transition-all duration-300 mb-6 md:mb-0">
              <div className="bg-white rounded-lg p-6 text-center h-full flex flex-col items-center dark:bg-dark-2 shadow-md md:shadow-none">
                <div className="w-16 h-16 md:w-20 md:h-20 mb-4 md:mb-6">
                  <img src={feature.icon} alt={feature.title} className="w-full h-full object-contain" />
                </div>
                <div className="flex-grow">
                  <h3 className="text-lg md:text-xl font-medium mb-2 md:mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 text-xs md:text-sm">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LittleMakerMethodology;